// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1BlG5","choiceBoxes":"toolbarselects_choiceBoxes__3oHlm","simpleField":"toolbarselects_simpleField__1RpZU"};